import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Table,
  Row,
  Col,
  Card,
  Tabs,
  Input,
  Select,
  message,
  Space
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import { _get, _post, _put, _delete } from "../../Utils/Helper";

const { Option } = Select;
const { TabPane } = Tabs;

const IncomeExpenseSettings = () => {
  const [newIncomeCategory, setNewIncomeCategory] = useState("");
  const [newExpenseCategory, setNewExpenseCategory] = useState("");
  const [newPaymentMethod, setNewPaymentMethod] = useState("");
  const [incomeCategories, setIncomeCategories] = useState<
    { id: number; name: string; source: string; transactionType: string }[]
  >([]);
  const [expenseCategories, setExpenseCategories] = useState<
    { id: number; name: string; source: string; transactionType: string }[]
  >([]);
  const [paymentMethods, setPaymentMethods] = useState<
    { id: number; name: string }[]
  >([]);
  const [incomeType, setIncomeType] = useState("school");
  const [expenseType, setExpenseType] = useState("school");
  const [incomeTransactionType, setIncomeTransactionType] = useState("service");
  const [expenseTransactionType, setExpenseTransactionType] =
    useState("service");

  // Fetch all data when the component loads
  useEffect(() => {
    fetchIncomeCategories();
    fetchExpenseCategories();
    fetchPaymentMethods();
  }, []);

  // const fetchIncomeCategories = () => {
  //   _get(
  //     "get-all-income",
  //     (data) => {
  //       console.log("API Response:", data); // Debugging API response

  //       // Handle single object response
  //       const categories = Array.isArray(data)
  //         ? data.map((category: any) => ({
  //             id: category.id,
  //             name: category.income_category_name,
  //             source: category.source,
  //             transactionType: category.transaction_type
  //           }))
  //         : [
  //             {
  //               id: data.id,
  //               name: data.income_category_name,
  //               source: data.source,
  //               transactionType: data.transaction_type
  //             }
  //           ];

  //       console.log("Mapped Categories:", categories); // Debugging mapped data
  //       setIncomeCategories(categories);
  //     },
  //     (err) => console.error("Failed to fetch income categories:", err)
  //   );
  // };

  const fetchIncomeCategories = () => {
    _get(
      "get-all-income",
      (data) => setIncomeCategories(data),
      (err) => console.error("Failed to fetch expense categories:", err)
    );
  };
  const fetchExpenseCategories = () => {
    _get(
      "get-all-exposes",
      (data) => setExpenseCategories(data),
      (err) => console.error("Failed to fetch expense categories:", err)
    );
  };

  const fetchPaymentMethods = () => {
    _get(
      "get-all-payment-methods",
      (data) => setPaymentMethods(data),
      (err) => console.error("Failed to fetch payment methods:", err)
    );
  };

  const handleAddIncomeCategory = () => {
    if (!newIncomeCategory.trim()) {
      message.error("Please enter a valid income category name.");
      return;
    }
    const payload = {
      incomeCategoryName: newIncomeCategory,
      source: incomeType,
      transactionType: incomeTransactionType
    };
    console.log(payload);
    _post(
      "new-income",
      payload,
      () => {
        message.success("Income category added successfully.");
        fetchIncomeCategories();
        setNewIncomeCategory("");
      },
      (err) => console.error("Failed to add income category:", err)
    );
  };

  const handleAddExpenseCategory = () => {
    if (!newExpenseCategory.trim()) {
      message.error("Please enter a valid expense category name.");
      return;
    }
    const payload = {
      categoryName: newExpenseCategory,
      source: expenseType,
      transactionType: expenseTransactionType
    };
    _post(
      "new-expose",
      payload,
      () => {
        message.success("Expense category added successfully.");
        fetchExpenseCategories();
        setNewExpenseCategory("");
      },
      (err) => console.error("Failed to add expense category:", err)
    );
  };

  const handleAddPaymentMethod = () => {
    if (!newPaymentMethod.trim()) {
      message.error("Please enter a valid payment method name.");
      return;
    }
    const payload = { paymentName: newPaymentMethod };
    _post(
      "new-payment-method",
      payload,
      () => {
        message.success("Payment method added successfully.");
        fetchPaymentMethods();
        setNewPaymentMethod("");
      },
      (err) => console.error("Failed to add payment method:", err)
    );
  };

  const handleEdit = (id: any, source: string) => {
    const updatedName = prompt("Enter new name:");
    if (!updatedName || !updatedName.trim()) {
      message.error("Please enter a valid name.");
      return;
    }

    const endpoint =
      source === "income"
        ? `update-income/${id}`
        : source === "expense"
        ? `update-expose/${id}`
        : `update-payment-method/${id}`;

    const payload =
      source === "income"
        ? { incomeCategoryName: updatedName }
        : source === "expense"
        ? { categoryName: updatedName }
        : { paymentName: updatedName };

    _put(
      endpoint,
      payload,
      () => {
        message.success(`${source} updated successfully.`);
        if (source === "income") fetchIncomeCategories();
        if (source === "expense") fetchExpenseCategories();
        if (source === "payment") fetchPaymentMethods();
      },
      (err) => console.error(`Failed to update ${source}:`, err)
    );
  };

  const handleDelete = (id: any, source: string) => {
    const endpoint =
      source === "income"
        ? `delete-income/${id}`
        : source === "expense"
        ? `delete-expose/${id}`
        : `delete-payment-method/${id}`;

    _delete(
      endpoint,
      () => {
        message.success(`${source} deleted successfully.`);
        if (source === "income") fetchIncomeCategories();
        if (source === "expense") fetchExpenseCategories();
        if (source === "payment") fetchPaymentMethods();
      },
      (err) => console.error(`Failed to delete ${source}:`, err)
    );
  };

  const routes = all_routes;

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Income & Expenses Settings</h3>
            {/* <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Report</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Income & Expenses Settings
                </li>
              </ol>
            </nav> */}
          </div>
          <TooltipOption />
        </div>

        <Row gutter={[16, 16]} className="mb-4">
          {/* Add Income Category */}
          <Col span={8}>
            <Card title="Add Income Category" bordered>
              <Form layout="vertical" onFinish={handleAddIncomeCategory}>
                <Form.Item label="Category Name" required>
                  <Input
                    value={newIncomeCategory}
                    onChange={(e) => setNewIncomeCategory(e.target.value)}
                  />
                </Form.Item>
                <Form.Item label="Type">
                  <Select
                    value={incomeType}
                    onChange={(value) => setIncomeType(value)}
                  >
                    <Option value="school">School</Option>
                    <Option value="extra">Extra</Option>
                  </Select>
                </Form.Item>
                <Form.Item label="Transaction Type">
                  <Select
                    value={incomeTransactionType}
                    onChange={(value) => setIncomeTransactionType(value)}
                  >
                    <Option value="service">Service</Option>
                    <Option value="item">Item</Option>
                  </Select>
                </Form.Item>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  htmlType="submit"
                >
                  Add Income Category
                </Button>
              </Form>
            </Card>
          </Col>

          {/* Add Expense Category */}
          <Col span={8}>
            <Card title="Add Expense Category" bordered>
              <Form layout="vertical" onFinish={handleAddExpenseCategory}>
                <Form.Item label="Category Name" required>
                  <Input
                    value={newExpenseCategory}
                    onChange={(e) => setNewExpenseCategory(e.target.value)}
                  />
                </Form.Item>
                <Form.Item label="Type">
                  <Select
                    value={expenseType}
                    onChange={(value) => setExpenseType(value)}
                  >
                    <Option value="school">School</Option>
                    <Option value="extra">Extra</Option>
                  </Select>
                </Form.Item>
                <Form.Item label="Transaction Type">
                  <Select
                    value={expenseTransactionType}
                    onChange={(value) => setExpenseTransactionType(value)}
                  >
                    <Option value="service">Service</Option>
                    <Option value="item">Item</Option>
                  </Select>
                </Form.Item>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  htmlType="submit"
                >
                  Add Expense Category
                </Button>
              </Form>
            </Card>
          </Col>

          {/* Add Payment Method */}
          <Col span={8}>
            <Card title="Add Payment Method" bordered>
              <Form layout="vertical" onFinish={handleAddPaymentMethod}>
                <Form.Item label="Payment Method Name" required>
                  <Input
                    value={newPaymentMethod}
                    onChange={(e) => setNewPaymentMethod(e.target.value)}
                  />
                </Form.Item>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  htmlType="submit"
                >
                  Add Payment Method
                </Button>
              </Form>
            </Card>
          </Col>
        </Row>

        {/* Tabs for Tables */}
        <Tabs defaultActiveKey="income">
          {/* Income Categories */}
          <TabPane tab="Income Categories" key="income">
            <Table
              dataSource={incomeCategories}
              columns={[
                {
                  title: "Category Name",
                  dataIndex: "income_category_name",
                  key: "income_category_name"
                },
                { title: "Type", dataIndex: "source", key: "source" },
                {
                  title: "Transaction Type",
                  dataIndex: "transaction_type",
                  key: "transaction_type"
                },
                {
                  title: "Actions",
                  key: "actions",
                  render: (_, record) => (
                    <Space>
                      <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record.id, "income")}
                      >
                        Edit
                      </Button>
                      <Button
                        type="link"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(record.id, "income")}
                      >
                        Delete
                      </Button>
                    </Space>
                  )
                }
              ]}
              rowKey="id"
              bordered
            />
          </TabPane>

          {/* Expense Categories */}
          <TabPane tab="Expense Categories" key="expense">
            <Table
              dataSource={expenseCategories}
              columns={[
                {
                  title: "Category Name",
                  dataIndex: "category_name",
                  key: "category_name"
                },
                { title: "Type", dataIndex: "source", key: "source" },
                {
                  title: "Transaction Type",
                  dataIndex: "transaction_type",
                  key: "transaction_type"
                },
                {
                  title: "Actions",
                  key: "actions",
                  render: (_, record) => (
                    <Space>
                      <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record.id, "expense")}
                      >
                        Edit
                      </Button>
                      <Button
                        type="link"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(record.id, "expense")}
                      >
                        Delete
                      </Button>
                    </Space>
                  )
                }
              ]}
              rowKey="id"
              bordered
            />
          </TabPane>

          {/* Payment Methods */}
          <TabPane tab="Payment Methods" key="payment">
            <Table
              dataSource={paymentMethods}
              columns={[
                {
                  title: "Payment Method",
                  dataIndex: "method_name",
                  key: "method_name"
                },
                {
                  title: "Actions",
                  key: "actions",
                  render: (_, record) => (
                    <Space>
                      <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record.id, "payment")}
                      >
                        Edit
                      </Button>
                      <Button
                        type="link"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(record.id, "payment")}
                      >
                        Delete
                      </Button>
                    </Space>
                  )
                }
              ]}
              rowKey="id"
              bordered
            />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default IncomeExpenseSettings;
